import { Navigate, Outlet, useLocation } from "react-router-dom";
import Auth from "../../../services/auth/AuthService";
import secureLocalStorage from "react-secure-storage";

const paramRequiredRoutes = ["/edit", "/PeriodicValidation", "/details"]
const paramRequiredRoutesRegex = [/\/filledForms\/\d+$/]

const checkIfParamRequiredRoute = (route: string) => {

    const indexes = paramRequiredRoutes.map((paramRequiredRoute) => {
        return {
            isAParamRequiredRoute: route.endsWith(paramRequiredRoute),
            index: route.lastIndexOf(paramRequiredRoute)
        };
    });

    paramRequiredRoutesRegex.forEach((paramRequiredRoute) => {
        indexes.push({
            isAParamRequiredRoute: paramRequiredRoute.test(route),
            index: route.search(/\/\d+$/)
        })
    })

    const foundRoute = indexes.find((result) => result.isAParamRequiredRoute);
    return foundRoute ? foundRoute : { isAParamRequiredRoute: false, index: 0 };
}

export const ProtectedRoute = ({
    allowedRoles,
}: {
    allowedRoles: number[];
}) => {
    // const { user, setAuth } = useAuth();
    const location = useLocation();
    const user = Auth.user;

    const { isAParamRequiredRoute, index } = checkIfParamRequiredRoute(location.pathname)
    var isParamMissing = (isAParamRequiredRoute && !location.state)

    const rowResponse = secureLocalStorage.getItem("rowParam")
    if (isParamMissing && rowResponse) {
        location.state = rowResponse
        isParamMissing = false
    }
    secureLocalStorage.removeItem("rowParam")

    if (user && allowedRoles.includes(user.role)) {
        return isParamMissing ? <Navigate to={location.pathname.substring(0, index)} replace /> : <Outlet />;
    } else {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
};
